import React, { Suspense, lazy } from "react";
import { FileDown } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { pdfMeta } from "@/data/indsatser";

// Code-split @react-pdf/renderer so it is never part of the initial bundle.
const Inner = lazy(() =>
  import("@/components/ProductPdf").then((m) => ({ default: m.ProductPdfButton }))
);

const Fallback = ({ label }) => (
  <span
    className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-[#1A2E24] px-6 py-3 font-medium opacity-80"
    data-testid="pdf-download-btn"
  >
    <FileDown className="h-4 w-4" /> {label}
  </span>
);

export const ProductPdfButton = (props) => {
  const { lang } = useLang();
  const L = pdfMeta[lang] ? lang : "da";
  // Do not pull the heavy @react-pdf chunk during react-snap prerender.
  if (typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap") {
    return <Fallback label={pdfMeta[L].button} />;
  }
  return (
    <Suspense fallback={<Fallback label={pdfMeta[L].button} />}>
      <Inner {...props} />
    </Suspense>
  );
};
